import React from "react"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"
import { useLocation } from "@reach/router"

const Head = ({
  title,
  description,
  children,
  image,
  cookie = true,
  favicon,
}) => {
  const { pathname } = useLocation()

  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          siteUrl
          title
          metaDescription
          defaultImage
        }
      }
    }
  `)
  const { siteUrl, defaultImage, metaDescription } = data.site.siteMetadata

  if (title === "Home") {
    title = "SciPlay | Social Casino Slots, Hyper Casual & Bingo Games"
  } else {
    title += " | SciPlay"
  }

  const seo = {
    title: title || data.site.siteMetadata.title,
    description: description || metaDescription,
    image: image || defaultImage,
    url: `${siteUrl}${pathname}`,
  }

  return (
    <Helmet>
      <title>{seo.title}</title>

      {children}

      <meta name="description" content={seo.description} />
      <meta
        name="robots"
        content="max-snippet:-1, max-image-preview:large, max-video-preview:-1"
      />
      <link rel="canonical" href={seo.url} />
      <meta property="og:locale" content="en_US" />
      <meta property="og:type" content="article" />
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:image" content={seo.image} />

      <meta
        property="og:url"
        content="https://www.sciplay.com/about-sciplay/"
      />
      <meta property="og:site_name" content="SciPlay" />
      <meta
        property="article:publisher"
        content="https://www.facebook.com/SciPlay.Games/"
      />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:title" content={seo.title} />

      {favicon && (
        <link rel="icon" href={favicon.gatsbyImageData.images.fallback.src} />
      )}
    </Helmet>
  )
}

export default Head
